import { Unifree } from '@yes.technology/react-toolkit'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18n-lite'
import CompositionButtons from '../CompositionButtons/CompositionButtons'
import { validateComposition } from '../../shared/FilterLanguage'

type FilterCompositionProps = {
  composition: string
  groupsLength: number
  handleComposition: (composition: string) => void
  handleCreateGroup: () => void
}

function FilterComposition({
  composition,
  groupsLength,
  handleComposition,
  handleCreateGroup
}: FilterCompositionProps) {
  const { t } = useTranslation()
  const [_, setValidationMessage] = useState('')
  const [isValidationError, setIsValidationError] = useState(false)
  const [internalComposition, setInternalComposition] = useState(composition)

  useEffect(() => {
    const debounceDescriptor = setTimeout(() => {
      const translateRegex = new RegExp(
        `\\b(${t('composition-operator.and')}|${t('composition-operator.or')})\\b`,
        'gi'
      )
      const removedTranslation = internalComposition.replace(
        translateRegex,
        (match) =>
          match.toUpperCase() === t('composition-operator.and') ? 'AND' : 'OR'
      )

      const validation = validateComposition(removedTranslation, groupsLength)

      setIsValidationError(!validation.success)

      if (!validation.success && validation.message)
        setValidationMessage(validation.message)
      else handleComposition(removedTranslation)
    }, 500)

    return () => clearTimeout(debounceDescriptor)
  }, [internalComposition, groupsLength, handleComposition, t])

  useEffect(() => {
    setInternalComposition(
      composition.replace(/\b(AND|OR)\b/gi, (match) =>
        match.toUpperCase() === 'AND'
          ? t('composition-operator.and')
          : t('composition-operator.or')
      )
    )
    setIsValidationError(false)
    setValidationMessage('')
  }, [composition, t])

  return (
    <>
      <div
        className='d-md-grid d-flex flex-column gap-2 flex-lg-grow-1 col-12 col-md-8 col-lg-3'
        style={{ gridAutoFlow: 'column' }}
      >
        <Unifree
          label={t('filter-fields.composition')}
          value={internalComposition}
          onChange={setInternalComposition}
          statusClass={isValidationError ? 'error' : 'default'}
        />
      </div>
      <CompositionButtons
        {...{ composition, handleComposition, handleCreateGroup }}
      />
    </>
  )
}

export default FilterComposition
